<template lang="pug">
div
  h1.title.is-3.has-text-info(style='margin-bottom: 5px;') Salas
    .buttons(style='margin-bottom: 10px;' )
      button.button.is-info.is-outlined(@click="refreshFake" :class="{ 'is-loading': refreshAnimation }")
        span.icon.is-small
          i.fas.fa-sync-alt
      button.button.is-primary.is-light(@click="addData" v-if="canCreateRooms")
        span.icon.is-small
          i.fas.fa-plus
  .columns.is-vcentered.is-multiline(v-if="salas.length")
      .column.is-full-mobile.is-half-tablet.is-one-third-desktop(v-for="sala in salas" :key="sala.id" style="cursor: pointer;" @click="selectSala(sala.id)")
        .card(style="position: relative;")
          .card-content
            button.button.is-small.is-outlined.is-light.is-info(
              style="position: absolute; top: 10px; right: 10px;"
              v-if="canEditRooms(sala)"
              @click.stop="editRoom(sala)"
              )
              span.icon.is-small
                i.fas.fa-edit
            span.tag.is-success(v-if="verificarNuevos(sala)" style="margin-bottom: 15px;") Nuevo
            .content
              p.title.is-4.has-text-centered {{ SalaTitle(sala) }}
              p.subtitle.is-7.has-text-centered.has-text-grey-light(v-if="sala.global") Global
              p.subtitle.is-7.has-text-centered.has-text-grey-light(
                v-if="sala.mensajes && sala.lista_participantes.length && !sala.global"
              ) {{ sala.lista_participantes.length }} {{ salas.grupo ? "grupos" : "usuarios" }}, {{ sala.mensajes }} mensaje{{ sala.mensajes > 1 ? "s" : "" }}.
              p.is-size-7(style="margin-top: 20px; margin-bottom: 0; font-weight: bold;" v-if="sala.ultimo_tiempo_remitente" ) Ultimo mensaje:
              p.ellipsis(style="margin-top: 5px; margin-bottom: 0;" v-if="sala.ultimo_tiempo_remitente" v-html="sala.ultimo_mensaje")
              span.is-size-7.has-text-grey-light.is-italic(
                v-if="sala.ultimo_tiempo_remitente"
              )
                span {{ formatoFecha(sala.ultimo_tiempo_remitente) }} - 
                span.has-text-info {{ userName(sala) }}
              p(style="margin-top: 20px; margin-bottom: 0;" v-if="!sala.ultimo_tiempo_remitente" ) Sin mensajes

  Modal(v-model="openModal")
    .modal-card
      header.modal-card-head
        p.modal-card-title {{ selectedId ? "Edición" : "Creación" }} de sala
      section.modal-card-body
        .field
          label.label(for="elmName") Nombre de la sala
          .control
            input.input(id="elmName" type="text" placeholder="Ingresa el nombre" v-model="objetivo.nombre")
        .field
          .control
            label.radio(style="margin-left: 15px;")
              input(type="radio" name="option" :value="0" v-model="type")
              span(style="margin-left: 5px;") Usuarios
            label.radio(style="margin-left: 15px;")
              input(type="radio" name="option"  :value="1" v-model="type")
              span(style="margin-left: 5px;") Grupos
            label.radio(style="margin-left: 15px;")
              input(type="radio" name="option"  :value="2" v-model="type")
              span(style="margin-left: 5px;") Global
        section(v-if="type !== 2")
          .columns
            .column
              .control.has-icons-left(:class="{'has-icons-right': search !== ''}")
                input.input.is-small.is-rounded(type="text" placeholder="Busqueda" v-model="search")
                span.icon.is-small.is-left.has-text-info
                  i.fas.fa-search
                span.icon.is-small.is-right.has-text-danger(
                  v-if="search !== ''"
                  @click="search = ''"
                  style="cursor: pointer; pointer-events: initial;")
                  i.fas.fa-times
          table.table.is-striped
            thead
              tr
                th {{ type === 0 ? "Correo" : "Nombre" }}
                th Estado
            tbody
              template(v-if="type === 0")
                tr(v-for="user in usuariosSearchAndSelect" :key="user.id")
                  td {{ user.email }}
                  td
                    .field
                      label.checkbox(@input="setElementUsuario(user.id, 'selected', !user.selected)")
                        input(type="checkbox" :checked="user.selected" )
                        span(style="margin-left: 5px;") {{ user.selected ? "Incluido" : "No seleccionado"}}
              template(v-else)
                tr(v-for="user in gruposSearchAndSelect" :key="user.id")
                  td {{ user.name }}
                  td
                    .field
                      label.checkbox(@input="setElementGrupo(user.id, 'selected', !user.selected)")
                        input(type="checkbox" :checked="user.selected" )
                        span(style="margin-left: 5px;") {{ user.selected ? "Incluido" : "No seleccionado"}}
      footer.modal-card-foot
        button.button.is-success(@click="saveData") Guardar
</template>

<script>
import { message } from "@/helpers/messaging";
import moment from "moment";
import Modal from "@/components/Modal";
import _get from "lodash/get";
import { mapState, mapActions } from "vuex";

export default {
  name: "SalasComponent",

  components: {
    Modal
  },

  data: () => ({
    messageSrv: message,
    openModal: false,
    refreshAnimation: false,
    type: 0,
    search: "",
    timersearch: null,
    selectedId: null,
    usuariosSelect: [],
    usuariosSearchAndSelect: [],
    gruposSelect: [],
    gruposSearchAndSelect: [],
    objetivo: {
      nombre: "",
      avatar: null,
      global: false,
      grupo: false,
      activa: true,
      creador: "",
      lista_participantes: [],
      ultimo_mensaje: null,
      ultimo_remitente: null,
      ultimo_tiempo_remitente: null
    }
  }),

  created() {
    this.refresh();
  },

  watch: {
    selectedId(val) {
      if (!val) {
        this.cleanFields();
      }
    },
    colegios_sel() {
      this.refresh();
    },
    search() {
      this.searcher();
    },
    usuariosSelect() {
      this.compareLists();
    },
    gruposSelect() {
      this.compareLists();
    },
    openModal(val) {
      if (val) {
        this.listUsuarioColegio();
        this.listGrupo();
      }
    },
    actualUsuariosSelect(val) {
      this.usuariosSelect = val;
    },
    actualGruposSelect(val) {
      this.gruposSelect = val;
    },
    type(val) {
      this.$set(this.toSave, "lista_participantes", []);
      switch (val) {
        case 0:
          this.$set(this.objetivo, "grupo", false);
          this.$set(this.objetivo, "global", false);
          break;
        case 1:
          this.$set(this.objetivo, "grupo", true);
          this.$set(this.objetivo, "global", false);
          break;
        case 2:
          this.$set(this.objetivo, "grupo", false);
          this.$set(this.objetivo, "global", true);
          break;
      }
    },
    salas(val) {
      if (Array.isArray(val) && val.length) {
        this.setNotifications();
      }
    }
  },

  computed: {
    ...mapState([
      "colegios_sel",
      "usuarios_list_colegio",
      "grupos_list",
      "salas_list_user",
      "user"
    ]),

    canCreateRooms() {
      return (
        _get(this.user, `userInfo.superuser`) ||
        _get(
          this.user,
          `userInfo.permisos.${_get(
            this.colegios_sel,
            "id",
            "none"
          )}.salas.creacion`
        )
      );
    },

    actualUsuariosSelect() {
      const existentUsers = !this.toSave.grupo
        ? this.objetivo.lista_participantes || []
        : [];
      return this.usuarios_list_colegio.map(elm => {
        elm.selected = !!existentUsers.find(gusr => gusr === elm.id);
        return elm;
      });
    },
    actualGruposSelect() {
      const existentGrupos = this.toSave.grupo
        ? this.objetivo.lista_participantes || []
        : [];
      return this.grupos_list.map(elm => {
        elm.selected = !!existentGrupos.find(gusr => gusr === elm.id);
        return elm;
      });
    },
    salas() {
      return this.salas_list_user;
    },

    toSave() {
      const objetivo = JSON.parse(JSON.stringify(this.objetivo));
      objetivo.creador =
        objetivo.creador || _get(this.$store.getters.userLogged, "id");
      objetivo.lista_participantes = [];
      return objetivo;
    },
    storing() {
      return this.$store.state.salas_load;
    }
  },

  methods: {
    ...mapActions([
      "listUsuarioSala",
      "listGrupo",
      "listUsuarioColegio",
      "storeSala",
      "setOneSalaUser"
    ]),

    setNotifications() {
      message.setTokenWithUserGroups({
        usuario: _get(this.user, "userInfo", null),
        salas: this.salas_list_user.map(sl => sl.id),
        colegio: this.colegios_sel
      });
    },
    canEditRooms(sala) {
      return (
        _get(this.user, `userInfo.superuser`) ||
        _get(sala, "creador") === _get(this.user, `userInfo.id`) ||
        _get(
          this.user,
          `userInfo.permisos.${_get(
            this.colegios_sel,
            "id",
            "none"
          )}.salas.modificacion`
        )
      );
    },
    editRoom(sala) {
      this.type = sala.global ? 2 : sala.grupo ? 1 : 0;
      this.search = "";
      let objetivo = {};
      objetivo.nombre = sala.nombre;
      objetivo.avatar = sala.avatar;
      objetivo.global = sala.global;
      objetivo.grupo = sala.grupo;
      objetivo.activa = sala.activa;
      objetivo.creador = sala.creador;
      objetivo.lista_participantes = sala.lista_participantes || [];
      objetivo.ultimo_mensaje = sala.ultimo_mensaje;
      objetivo.ultimo_remitente = sala.ultimo_remitente;
      objetivo.ultimo_tiempo_remitente = sala.ultimo_tiempo_remitente;
      this.objetivo = objetivo;
      this.openModal = true;
      this.selectedId = sala.id;
    },

    verificarNuevos(sala) {
      const lastDatePulled = JSON.parse(
        localStorage.getItem("lastDateMessage")
      );
      const ultimoTiempo = _get(sala, "ultimo_tiempo_remitente");
      const ultimpoTraido = _get(lastDatePulled, sala.id);
      return ultimoTiempo && ultimpoTraido && ultimoTiempo > ultimpoTraido;
    },

    refreshFake() {
      this.refresh();
      this.refreshAnimation = true;
      setTimeout(() => {
        this.refreshAnimation = false;
      }, 1500);
    },
    userName(mensaje) {
      return `@${_get(mensaje, "user.name") ||
        (_get(mensaje, "user.email")
          ? _get(mensaje, "user.email").split("@")[0]
          : "Indefinido")}`;
    },
    searcher() {
      if (this.timersearch) clearTimeout(this.timersearch);
      this.timersearch = setTimeout(() => this.compareLists(), 300);
    },
    cleanFields() {
      this.type = 0;
      this.search = "";
      let objetivo = {};
      objetivo.nombre = "";
      objetivo.avatar = null;
      objetivo.global = false;
      objetivo.grupo = false;
      objetivo.activa = true;
      objetivo.creador = "";
      objetivo.lista_participantes = [];
      objetivo.ultimo_mensaje = null;
      objetivo.ultimo_remitente = null;
      objetivo.ultimo_tiempo_remitente = null;
      this.objetivo = objetivo;
    },
    refresh() {
      this.listUsuarioSala();
    },
    setElementUsuario(id, destiny, value) {
      const index = this.usuariosSelect.findIndex(usr => usr.id === id);
      const element = this.usuariosSelect[index];
      element[destiny] = value;
      this.$set(this.usuariosSelect, index, element);
    },
    setElementGrupo(id, destiny, value) {
      const index = this.gruposSelect.findIndex(usr => usr.id === id);
      const element = this.gruposSelect[index];
      element[destiny] = value;
      this.$set(this.gruposSelect, index, element);
    },
    compareLists() {
      const search = this.search;
      if (search === "") {
        this.usuariosSearchAndSelect = this.usuariosSelect;
        this.gruposSearchAndSelect = this.gruposSelect;
      } else {
        this.usuariosSearchAndSelect = this.usuariosSelect.filter(
          usr =>
            (typeof usr.email === "string" && usr.email.indexOf(search) > -1) ||
            (typeof usr.name === "string" && usr.name.indexOf(search) > -1)
        );
        this.gruposSearchAndSelect = this.gruposSelect.filter(
          usr => typeof usr.name === "string" && usr.name.indexOf(search) > -1
        );
      }
    },
    addData() {
      this.openModal = true;
    },
    SalaTitle(sala) {
      return sala.nombre;
    },
    formatoFecha(epoch) {
      const day = moment.unix(epoch);
      return `${this.selectDia(day.day())}, ${day.format("YYYY-MM-DD h:mm a")}`;
    },
    selectSala(id) {
      this.setOneSalaUser(id);
      this.$router.push("/sala/" + id);
    },
    selectDia(numDia) {
      switch (numDia) {
        case 0:
          return "Domingo";
        case 1:
          return "Lunes";
        case 2:
          return "Martes";
        case 3:
          return "Miércoles";
        case 4:
          return "Jueves";
        case 5:
          return "Viernes";
        case 6:
          return "Sábado";
        default:
          return "Domingo";
      }
    },
    async saveData() {
      let action;
      const tosave = JSON.parse(JSON.stringify(this.toSave));
      tosave.lista_participantes = !tosave.global
        ? !tosave.grupo
          ? this.usuariosSelect.filter(usr => usr.selected).map(usr => usr.id)
          : this.gruposSelect.filter(grp => grp.selected).map(grp => grp.id)
        : [];
      if (!this.selectedId) {
        action = this.$store.dispatch("storeSala", {
          data: tosave
        });
      } else {
        action = this.$store.dispatch("updateSala", {
          id: this.selectedId,
          data: tosave
        });
      }
      try {
        await action;
        this.$toastr(
          "success",
          this.selectedId
            ? "El registro se actualizó correctamente."
            : "El registro se creó correctamente."
        );
        this.refresh();
        this.cleanFields();
      } catch (error) {
        console.error(error);
        this.$toastr(
          "error",
          this.selectedId
            ? "El registro no se pudo actualizar."
            : "El registro no se pudo crear."
        );
      }
      this.selectedId = null;
      this.openModal = false;
    }
  }
};
</script>
